export default {
  sections: {
    title: {
      title: 'Tilaus vahvistettu',
      description: 'Lahjakorttisi on ostettu onnistuneesti',
    },
    instructions: {
      title: 'Tarkista sähköpostisi',
      description:
        'Olemme lähettäneet lahjakorttisi tiedot ja kuitin sähköpostiosoitteeseesi. Lahjakortin koodi saapuu 5–10 minuutin kuluessa.',
    },
    details: {
      total: 'Yhteensä',
      order_number: 'Tilausnumero',
    },
    footer: {
      help: 'Teknologiakumppanimme Foodamigos auttaa meitä lahjakorttien hallinnassa. Jos et saa lahjakorttia tai et löydä sitä, ota yhteyttä osoitteeseen {{email}}',
      questions: 'Jos sinulla on yleisiä kysymyksiä lunastamisesta, ota meihin suoraan yhteyttä osoitteessa {{email}}',
    },
  },
  buttons: {
    go_home: 'Palaa etusivulle',
    download_pdfs: 'Lataa lahjakortti PDF-muodossa',
  },
};
